import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { TableHeader } from 'components/table/table-content';
import { Filters } from 'elements/Filter';
import { PubSub } from 'lib/event/PubSub';
import { FilterManager } from 'lib/tables/FilterManager';
import { AsyncErrorHandler } from 'lib/ui';
import { PenBracketTypeDto } from 'models/pen/PenBracketType';
import { PenBracketTypeService } from 'services/pen/pen-bracket-type-service';

@autoinject
export class PenBracketTypeList {
  protected tableData: Array<PenBracketTypeDto>;
  protected activeTableRow: number;

  protected tableHeaders: TableHeader<PenBracketTypeDto>[] = [{ key: 'Name', label: 'general.name', sortable: true }];

  constructor(
    private eventAggregator: EventAggregator,
    protected fm: FilterManager,
    protected penBracketTypeService: PenBracketTypeService,
    private pubsub: PubSub
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.updateView();
    });
  }

  protected async attached() {
    this.eventAggregator.subscribe('penBracketTypeReset', () => {
      this.activeTableRow = null;
      return this.updateView();
    });

    this.fm.init({
      context: 'pen-bracket-type-list',
      storageKey: 'pen-bracket-type-list',
      filters: {
        //TODO
      } satisfies Filters,
      defaultFilters: {
        //TOD
      },
    });

    this.updateView();
  }

  @AsyncErrorHandler
  async updateView() {
    const response = await this.penBracketTypeService.getPenDesignTypes(this.fm.queryFilter);

    if (!response) return;
    this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;

    this.tableData = response.data;
  }

  protected setOrderByColumn(column: string) {
    this.fm.setOrderByColumn(column);
  }

  protected detached() {
    this.pubsub.unsub();
  }

  protected unbind() {
    this.pubsub.unsub();
  }
}
